module.exports = __webpack_public_path__ + "img/8_1.bdd5d123.png";